/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */
import {
  Track,
  TrackType
}                        from './track';
import { DecisionPoint } from './decision.point';

export enum SwitchType {
  NONE   = 0,
  SPRING = 1,
  DTMF   = 2,
  POWER  = 3,
  MANUAL = 4
}

/**
 *
 * @class Connection
 *
 * @brief a single route between two tracks, through a switch at a given decision point.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2019
 *
 */
export class Connection {

  /** @var number unique id of this connection */
  public       _id: number             = -1;

  /** @var DecisionPoint|null the decision point for route */
  public       _dp: DecisionPoint|null = null;

  /** @var Track|null the source track */
  public     _from: Track|null         = null;

  /** @var Track|null the destination track */
  public       _to: Track|null         = null;

  /** @var SwitchType the switch kind */
  public     _type: SwitchType         = SwitchType.NONE;

  /** @var number the switch speed for this route */
  public    _speed: number             = 0.0;

  /** @var number[] ids for connections (in this bundle) which this one does not block */
  public _parallel: number[]           = [];

  /** @var number zero based index forms item */
  public      _nth: number             = -1;

  /** @brief standard constructor */
  constructor(   id: number,
                 dp: DecisionPoint|null,
               from: Track|null,
                 to: Track|null,
               type: string,
              speed: number,
                  p: number[],
                nth: number) {

    this._id       = id;
    this._dp       = dp;
    this._from     = from;
    this._to       = to;
    this._type     = Connection.typeFromString(type);
    this._speed    = speed;
    this._parallel = p;
    this._nth      = nth;
  }

  /** @brief convert track type to a string */
  public static typeToString(type: SwitchType): string {

    switch (type) {
      case SwitchType.NONE:   return 'N';
      case SwitchType.SPRING: return 'S';
      case SwitchType.DTMF:   return 'D';
      case SwitchType.POWER:  return 'P';
      case SwitchType.MANUAL: return 'M';
    }

    return '';
  }

  /** @brief convert track string to a type */
  public static typeFromString(type: string): SwitchType {

    const tmp: string = type.toLowerCase().trim();

    if (tmp === 'n') {

      return SwitchType.NONE;

    } else if (tmp === 's') {

      return SwitchType.SPRING;

    } else if (tmp === 'd') {

      return SwitchType.DTMF;

    } else if (tmp === 'p') {

      return SwitchType.POWER;

    } else if (tmp === 'm') {

      return SwitchType.MANUAL;
    }

    return SwitchType.NONE;
  }
}
